import layoutTop from "./layout/top.vue"; // 头部区域
import layoutPreview from "./layout-preview/index.vue"; // 组件预览区域

import layoutSortable from "./layout/right.vue"; // 组件顺序区域
import zoom from "./layout/zoom.vue"; // 放大缩小

import SvgIcon from '../design/components/SvgIcon';
import "./index.scss";
import './Forms';
export default {
  i18n: require("./i18n"),
  components: {
    layoutTop: layoutTop,
    layoutPreview: layoutPreview,
    layoutSortable: layoutSortable,
    zoom: zoom,
    SvgIcon: SvgIcon
  }
};